<template>
  <div class="testimonial-card">
    <div class="head">
      <img
        :alt="testimonial.logo.alt"
        :height="48"
        loading="lazy"
        :src="`${testimonial.logo.src}?fm=png&auto=format&h=48&w=auto`"
        :srcset="`${testimonial.logo.src}?fm=png&auto=format&h=48&w=auto&dpr=1 1x, ${testimonial.logo.src}?fm=png&auto=format&h=48&w=auto&fit=max&q=40&dpr=2 2x, ${testimonial.logo.src}?fm=png&auto=format&h=48&w=auto&fit=max&q=20&dpr=3 3x`"
        :width="
          Math.round(48 * (testimonial.logo.width / testimonial.logo.height))
        "
      >
    </div>
    <div class="rating">
      <div class="stars">
        <img
          v-for="n in 4"
          :key="n"
          alt="star"
          height="20"
          loading="lazy"
          src="@/assets/svg/star.svg"
          width="20"
        >
        <img
          alt="last star"
          height="20"
          loading="lazy"
          src="@/assets/svg/star-not-complete.svg"
          width="20"
        >
      </div>
    </div>
    <UiComponentParagraph class="body">
      {{ quotationMarkStart }}{{ testimonial.quote
      }}{{ quotationMarkEnd }}
    </UiComponentParagraph>
    <AtomButton
      v-if="testimonial.slug"
      :to="testimonial.slug"
      type="text"
    >
      <slot /><UiComponentIcon type="arrow-right" />
    </AtomButton>
    <div class="footer">
      <div class="left">
        <img
          :alt="testimonial.customer.avatar.alt"
          :height="48"
          loading="lazy"
          :src="`${testimonial.customer.avatar.src}?fm=jpg&auto=format&h=48&w=48`"
          :srcset="`${testimonial.customer.avatar.src}?fm=jpg&auto=format&h=48&w=48&dpr=1 1x, ${testimonial.customer.avatar.src}?fm=jpg&auto=format&h=48&w=48&fit=max&q=40&dpr=2 2x, ${testimonial.customer.avatar.src}?fm=jpg&auto=format&h=48&w=48&fit=max&q=20&dpr=3 3x`"
          :width="48"
        >
      </div>
      <div class="right">
        <UiComponentParagraph class="name">
          {{
            testimonial.customer.name
          }}
        </UiComponentParagraph>
        <UiComponentParagraph
          class="position"
          size="s"
        >
          {{
            testimonial.customer.position
          }}
        </UiComponentParagraph>
      </div>
    </div>
  </div>
</template>

<script setup>
// Composables
const { locale } = useI18n()

// Props
const props = defineProps({
  testimonial: {
    required: true,
    type: Object,
  },
})

// Computed Properties
const quotationMarkStart = computed(() => {
  return locale.value === 'fr' ? '« ' : '"'
})

const quotationMarkEnd = computed(() => {
  return locale.value === 'fr' ? ' »' : '"'
})
</script>

<style lang="postcss" scoped>
.testimonial-card {
  @apply flex flex-col h-auto p-8 border-2 border-grey-blue-200 rounded-4xl !important;

  @screen md {
    @apply p-12;
  }

  @screen lg {
    @apply p-10;
  }

  .head {
    img {
      @apply h-12 w-auto;
    }
  }

  .rating {
    @apply flex flex-row w-full mt-4;

    .stars {
      @apply flex flex-row;
    }

    .stars + span {
      @apply ml-2.5;
    }
  }

  .body {
    @apply mt-4 text-grey-blue-600;
  }

  .button {
    @apply justify-start mt-4 mb-6 px-0 font-normal text-livestorm-blue-700 !important;

    .icon {
      @apply text-livestorm-blue-700;
    }
  }

  .footer {
    @apply flex flex-row mt-auto;

    .left {
      @apply flex-shrink-0 w-12 h-12 rounded-full overflow-hidden;

      img {
        @apply h-full w-auto;
      }
    }

    .right {
      @apply flex flex-col justify-center ml-3;

      .name {
        @apply text-winter-green-900;
      }

      .position {
        @apply text-grey-blue-600 mt-0 whitespace-nowrap;
      }
    }
  }
}
</style>
